<template>
  <div class="flex flex-col justify-center items-center">
    <div class="figure animate-pulse">
      <img v-if="loaded" :src="src" :alt="name" @click.stop="handleClick" />
      <img v-else src="./assets/loading.svg" alt="头像" />
    </div>
    <div class="mt-4 w-full text-center truncate">{{ name }}</div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Figure extends Vue {
  @Prop({ type: String }) src!: string;
  @Prop({ type: String }) name!: string;
  @Prop({ type: Number }) index!: number;

  loaded = false;
  mask = false;

  mounted() {
    this.initImage();
  }
  initImage() {
    const image = new Image();
    image.src = this.src;
    image.onload = () => {
      this.loaded = true;
    };
  }
  handleClick() {
    this.$emit('selected', this.index);
  }
}
</script>

<style scoped>
.figure {
  @apply w-20 h-20 flex justify-center items-center rounded-full overflow-hidden bg-base hover:shadow-2xl;
}
</style>
